<svelte:options customElement="hb-terms-doc-templates" />

<script lang="ts">
  import pkg from "../../../package.json";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  // import GDPR from "@app/html/GDPR.svelte";
  // import ItPolicy from "@app/html/ItPolicy.svelte.bk";
  import itPrivacyContent from "./libs/privacyItContent";
  import itCookieContent from "./libs/cookieItContent";
  import enCookieContent from "./libs/cookieEnContent";
  import type { Component, IDoc, ITPrivacy } from "./types/webcomponent.type";
  import { dictionary } from "./libs/i18n";
  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",
    // style,
    i18nlang,
    data,
  }: Component = $props();
  let translator: LanguageTranslator;

  let doc: IDoc | undefined = $state(undefined);

  $effect(() => {
    // if (style) {
    // }

    if (!translator) {
      translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    } else if (
      translator &&
      i18nlang &&
      translator.lang &&
      translator.lang !== i18nlang
    ) {
      translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    }

    if (data && typeof data === "string") {
      try {
        const json: Component["data"] = JSON.parse(data);
        switch (json.id) {
          case "privacy-doc-italian":
            doc = itPrivacyContent(json);
            break;
          case "cookie-doc-italian":
            doc = itCookieContent(json);
            break;
          case "cookie-doc-english":
            doc = enCookieContent(json);
            break;
          case "cookie-doc":
            doc = itCookieContent(json);
            break;
        }
      } catch (err) {
        console.error("parsing data", err);
      }
    }
  });
  addComponent({ repoName: "@htmlbricks/hb-table", version: pkg.version });
</script>

{#if doc?.title && doc.chapters?.length}
  <h1 part="h1">{doc.title}</h1>
  {#each doc.chapters.filter((f) => f.key) as chapter (chapter.key)}
    {#if chapter.paragraphs?.length}
      <h2 part="h2">{chapter.index}. {chapter.title}</h2>
      {#each chapter.paragraphs.filter((f) => f.key) as paragraph (paragraph.key)}
        {#if paragraph.title}
          <h3>{paragraph.title}</h3>
        {/if}
        {#if paragraph.content}
          <p part="p">
            {paragraph.content}
          </p>
        {/if}
        {#if paragraph.list?.length}
          <ul part="ul">
            {#each paragraph.list.filter((f) => f.key) as listItem (listItem.key)}
              <li part="li">{listItem.content}</li>
            {/each}
          </ul>
        {/if}
        {#if paragraph.table?.headers && paragraph.table.rows?.length}
          <hb-table
            disablepagination="yes"
            size="1000"
            headers={JSON.stringify(paragraph.table.headers)}
            rows={JSON.stringify(paragraph.table.rows)}
          ></hb-table>
        {/if}
      {/each}
    {/if}
  {/each}
{:else}
  invalid doc params
{/if}

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
